export const encodePathSegment = (value) =>
  encodeURIComponent(String(value ?? "").trim());

export const getTrimmedCompanyContext = (clientName, companyName) => ({
  client:  String(clientName  || "").trim(),
  company: String(companyName || "").trim(),
});

export const mapFeatureKey = (key) => {
  if (!key) return key;
  if (key === "create") return "add";
  if (key === "delete") return "remove";
  return key;
};